/**
 * Default configuration for ludicrous-gateway
 * Used as fallback when no config file is provided
 */

import type { GatewayConfig } from "../types/config.js";

/**
 * Default gateway configuration
 */
export const defaultConfig: GatewayConfig = {
  server: {
    listen: "127.0.0.1:8787",
    timeout_ms: 300000, // 5 minutes
  },

  routing: {
    default_provider: "anthropic",
    rules: [],
  },

  providers: [
    {
      name: "anthropic",
      type: "anthropic",
      enabled: true,
      subscription_passthrough: true,
    },
  ],

  health: {
    check_interval_seconds: 30,
    circuit_breaker: {
      failure_threshold: 3,
      recovery_timeout_seconds: 60,
    },
  },

  logging: {
    level: "info",
    format: "text",
  },
};

/**
 * Get a deep copy of the default config
 */
export function getDefaultConfig(): GatewayConfig {
  return JSON.parse(JSON.stringify(defaultConfig)) as GatewayConfig;
}
